export default {
  state: {
    previewFile: null,
    previewStatus: false,
    isPlaying: true
  },
  mutations: {
    INIT_PREVIEW(state, file) {
      state.previewFile = file
      state.previewStatus = true
      state.isPlaying = true
      window.clevertap.event.push('LMS File opened')
    },
    REMOVE_PREVIEW_FILE(state) {
      state.previewFile = null
      state.previewStatus = false
    },
    UPDATE_PREVIEW_STATUS(state, status) {
      state.previewStatus = status
    },
    UPDATE_PLAYING_STATUS(state, status) {
      state.isPlaying = status
    }
  },
  getters: {
    previewFile: state => state.previewFile,
    previewStatus: state => state.previewStatus,
    playing: state => state.isPlaying,
  }
}